import { render, staticRenderFns } from "./resourceBox.vue?vue&type=template&id=bbaf965e&scoped=true"
import script from "./resourceBox.vue?vue&type=script&lang=js"
export * from "./resourceBox.vue?vue&type=script&lang=js"
import style0 from "./resourceBox.vue?vue&type=style&index=0&id=bbaf965e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaf965e",
  null
  
)

export default component.exports